import { render, staticRenderFns } from "./ScadaJunctionsSettings.vue?vue&type=template&id=473d8711&"
import script from "./ScadaJunctionsSettings.vue?vue&type=script&lang=js&"
export * from "./ScadaJunctionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports